import { MutableRefObject, useEffect, useRef, useState } from 'react';

import { AudioHandler } from '../../../helpers/audio-helper';

const smoothValue = (rawValue: number, value: number) => {
    const difference = rawValue - value;
    let smoothCoefficient = 0.3;
    if (difference > 0) {
        smoothCoefficient = 0.8;
    }
    return Math.trunc((value + difference * smoothCoefficient) * 1000) / 1000;
};
export const useDiagnosticVolumeLevel = (audioHandlerRef?: MutableRefObject<AudioHandler | number | null>) => {
    const [volumeLvl, setVolumeLvl] = useState(0);
    const smoothedVolume = useRef(volumeLvl);
    useEffect(() => {
        let animationFrameId: number;

        const updateVolumeLevel = () => {
            let rawVolume: number;
            if (!audioHandlerRef?.current || typeof audioHandlerRef?.current === 'number') {
                rawVolume = (audioHandlerRef?.current as number | undefined) || 0;
            } else {
                rawVolume = audioHandlerRef.current.volumeLevel;
            }
            smoothedVolume.current = smoothValue(rawVolume, smoothedVolume.current);

            setVolumeLvl(smoothedVolume.current);
            animationFrameId = requestAnimationFrame(updateVolumeLevel);
        };
        updateVolumeLevel();
        return () => {
            cancelAnimationFrame(animationFrameId);
        };
    }, [audioHandlerRef]);

    return volumeLvl;
};
